import { FC, useMemo } from 'react';
import { HTHInteractiveMapMapBlockPolygon } from './HTHInteractiveMapMapBlockPolygon';
import { millisecondsSevenDays } from '@monorepo/helpers';
import { typeHTHTerritory, typeHTHFace, typePublicMinistryDoc } from '@monorepo/models';

type propsType = {
    handleSelectTerritory: (territoryNumber: string) => void;
    polygon: typeHTHFace;
    publicMinistryDoc: typePublicMinistryDoc;
    selectionMode: boolean;
    t: typeHTHTerritory;
};

const colors = [
    '#2ecc71',
    '#58d68d',
    '#82e0aa',
    '#f7dc6f',
    '#f4d03f',
    '#f1c40f',
    '#f39c12',
    '#e67e22',
    '#d35400',
    '#e74c3c',
    '#c0392b',
    '#922b21' 
];

export const HTHInteractiveMapMapActivity: FC<propsType> = ({
    handleSelectTerritory, polygon, publicMinistryDoc, selectionMode, t
}) => {
    const polygonColor: string | undefined = useMemo(() => {
        const monthlyService = publicMinistryDoc.monthlyServices
            .find(ms => ms.services.find(s => s.id === polygon.serviceDates.slice(-1)[0]?.serviceId))
        ;
        if (monthlyService) {
            const serviceDate = new Date(monthlyService.year, monthlyService.month, 1); 
            const now = new Date();
            const diffMs = now.getTime() - serviceDate.getTime();
            const diffWeeks = Math.floor(diffMs / millisecondsSevenDays);
            if (diffWeeks <= 0) {
                return colors[0];
            }
            if (diffWeeks >= colors.length) {
                return colors[colors.length - 1];
            }
            return colors[diffWeeks];
        }
        return 'black';
    }, [publicMinistryDoc, t]);

    return (
        <>
        <HTHInteractiveMapMapBlockPolygon
            color={polygonColor}
            onClick={() => {
                if (selectionMode) {
                    handleSelectTerritory(t.territoryNumber);
                } else {
                    // openModalHandler(t.territoryNumber);
                }
            }}
            path={[polygon.coordsPoint1, polygon.coordsPoint2, polygon.coordsPoint3]}
            strokeColor={polygonColor}
            windowLabel={`T ${t.number} - Manzana ${polygon.block}: ${polygon.street}`}
        />
        </>
    );
}
